import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { HeaderAppearanceEvents } from '@unicup-ticketing/core';
import { Dispatcher } from '@ngrx/signals/events';

@Component({
  selector: 'ticketing-data-privacy',
  imports: [],
  templateUrl: './data-privacy.component.html',
  styleUrl: './data-privacy.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataPrivacyComponent implements OnInit {
  private readonly dispatcher = inject(Dispatcher);

  ngOnInit(): void {
    this.dispatcher.dispatch(HeaderAppearanceEvents.requestUnhero());
  }
}
